import { render } from "./page-governance.vue?vue&type=template&id=afb54bd0&scoped=true"
import script from "./page-governance.vue?vue&type=script&lang=js"
export * from "./page-governance.vue?vue&type=script&lang=js"

import "./page-governance.vue?vue&type=style&index=0&id=afb54bd0&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb54bd0"]])

export default __exports__